window.addEventListener('DOMContentLoaded', () => {
  let intervalCounter = 0;
  let placeNotifyCounter = 0;
  let sellingPlanCounter = 0;

  const preOrderComingSoonInterval = setInterval(() => {
    const preOrderComingSoon = document.querySelector('.gPreorderComingSoonBtn');

    if (!!preOrderComingSoon && intervalCounter < 50) {

      hideQuantity()
      clearInterval(preOrderComingSoonInterval);

    } else if (intervalCounter >= 50) clearInterval(preOrderComingSoonInterval);

    intervalCounter += 1;

  }, 300);

  const placeNotifyInterval = setInterval(() => {
    const preOrderButton = document.querySelector('.gPreorderBtn');

    if (!!preOrderButton && placeNotifyCounter < 50) {

      placeNotify()
      clearInterval(placeNotifyInterval);

    } else if (placeNotifyCounter >= 50) clearInterval(placeNotifyInterval);

    placeNotifyCounter += 1;

  }, 300);

  const sellingPlanInterval = setInterval(() => {
    const preOrderSellingPlan = document.querySelector('.gPreorderSellingPlanWrapper');

    if (!!preOrderSellingPlan && sellingPlanCounter < 50) {

      placeSellingPlan(preOrderSellingPlan)
      clearInterval(sellingPlanInterval);

    } else if (sellingPlanCounter >= 50) clearInterval(sellingPlanInterval);

    sellingPlanCounter += 1;

  }, 300);
})

function hideQuantity() {
  const quantityInput = document.querySelector('.product__ctas hh-broadcast:not(.product__atc-container)');

  quantityInput.style.display = 'none';
}

function placeNotify() {
  const countdown = document.querySelector('.gPreorderCountdownWrapper');
  const notifyBlock = document.querySelector('#Globo-Back-In-Stock')
  const previousElement = document.querySelector('.product__ctas');

  if (!!!previousElement) return;

  if (notifyBlock) previousElement.insertAdjacentElement('afterend', notifyBlock)
  if (countdown) previousElement.insertAdjacentElement('afterend', countdown)
}

function placeSellingPlan(preOrderSellingPlan) {
  const previousElement = document.querySelector('.product__ctas');

  if (!!!previousElement) return;

  previousElement.insertAdjacentElement('beforeBegin', preOrderSellingPlan)
}
